require('./angular');
module.exports = angular;



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular/index.js
 ** module id = 587
 ** module chunks = 1
 **/